// @ts-check

import { useCallback } from "react";
import Consts from "../consts";
import { useUserPreferences } from "./useUserPreferences";

/**
 * Custom hook for managing side navigation in user preferences.
 */
export const useUserSideNav = () => {
  const {
    mergedPreferences,
    globalUserPreferences,
    updatePreferencesForGlobalUser,
  } = useUserPreferences();

  const setSideNav = useCallback(
    /**
     * @param {user_prefs.SideNav} newSideNav
     * @returns {Promise<boolean>}
     */
    async (newSideNav) => {
      return updatePreferencesForGlobalUser({
        ...globalUserPreferences,
        sideNav: newSideNav,
      });
    },
    [globalUserPreferences, updatePreferencesForGlobalUser]
  );

  const setKeepExpanded = useCallback(
    /**
     * @param {boolean} keepExpanded
     * @returns {Promise<boolean>}
     */
    async (keepExpanded) => {
      return setSideNav({
        ...mergedPreferences?.sideNav,
        keepExpanded,
      });
    },
    [mergedPreferences, setSideNav]
  );

  return {
    sideNav: mergedPreferences?.sideNav || Consts.defaultPreferences.sideNav,
    setSideNav,
    setKeepExpanded,
  };
};
